import React from 'react';

import { Stack, Typography } from '@mui/material';
import { green, grey, red } from '@mui/material/colors';

import { audMoney } from './packageCategories';
import type { RoomPricing } from './types';

type OtaVsSellCellProps = {
  pricing: RoomPricing | undefined;
  selectedLos: number;
};

export default function OtaVsSellCell({ pricing, selectedLos }: OtaVsSellCellProps) {
  const otaPrice = Number(pricing?.otaPrice) || 0;
  const sell = Number(pricing?.sellByLos[selectedLos]) || 0;
  if (otaPrice <= 0 || sell <= 0) {
    return <Typography color="text.disabled">—</Typography>;
  }

  const disc = ((otaPrice - sell) / otaPrice) * 100;
  const color = disc >= 10 ? green[700] : disc >= 0 ? grey[600] : red[700];

  return (
    <Stack alignItems="center" spacing={0}>
      <Typography fontWeight={500} sx={{ color }} variant="body2">
        {disc >= 0 ? '+' : ''}
        {disc.toFixed(1)}%
      </Typography>
      <Typography color="text.secondary" variant="caption">
        {audMoney(sell)}
      </Typography>
    </Stack>
  );
}
